module.exports = __webpack_public_path__ + "img/brand--promart.8051bbfe.png";